import { DatePicker, Form } from 'antd'
import locale from 'antd/es/date-picker/locale/es_ES'
import { FormComponentProps } from 'antd/lib/form'
import React from 'react'
import styles from './DatePickerInput.module.scss'

interface IProps extends FormComponentProps {
  rules?: any[]
  label: string
  name: string
  onChange?: any
  disabled?: boolean
  inputProps?: any
  initialValue?: string | moment.Moment
  disabledDate?: any
}

const DatePickerInput: React.FC<IProps> = ({ form, rules = [], label, name, onChange, disabled = false, inputProps = { defaultMode: 'date' }, initialValue, disabledDate }: IProps) => {
  const { getFieldDecorator } = form
  const { defaultMode, ...props } = inputProps

  const [isRequired, setIsRequired] = React.useState(false)
  const [mode, setMode] = React.useState(defaultMode)

  React.useEffect(() => {
    if (rules && rules.length) {
      setIsRequired(rules.some((item) => item.required === true))
    }
  }, [rules])

  const handlerChange = (value: any) => {
    onChange && onChange(value)
  }

  const inputOptions = {
    rules,
    ...(initialValue ? { initialValue } : {}),
  } as any

  return (
    <Form.Item className={styles.input} key={name} label={label} required={isRequired}>
      {getFieldDecorator(
        name,
        inputOptions
      )(
        <DatePicker
          disabled={disabled}
          disabledDate={disabledDate}
          format={props?.format || 'DD-MM-yyyy'}
          locale={locale}
          mode={mode}
          onChange={handlerChange}
          onOpenChange={(open) => open && setMode(defaultMode)}
          onPanelChange={(_, mode) => setMode(mode || 'month')}
          {...props}
        />
      )}
    </Form.Item>
  )
}

export default DatePickerInput
